/**
 * @generated SignedSource<<df4e897c7c13b4459a353d818d30e9c9>>
 * @relayHash f8b883d035357512cc488bf38320eca3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9fa1deee69a7d7c1131a9266bda3498682040004679dac5904e341bd66455aa9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly widgets: ReadonlyArray<{
      readonly __typename: "CsmAiWidgetConfig";
      readonly " $fragmentSpreads": FragmentRefs<"Install_AtlassianCsmWidgetConfiguration" | "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery = {
  response: HelpCenterSettingsWidgetConfigurationInstallAppQuery$data;
  variables: HelpCenterSettingsWidgetConfigurationInstallAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EMBED"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "Install_AtlassianCsmWidgetConfiguration"
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "allowedDomains"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isAnonymousAccessEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEnabled"
                      },
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "position"
                      },
                      {
                        "concreteType": "CsmAiWidgetBrandingTheme",
                        "kind": "LinkedField",
                        "name": "theme",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "colorVibeVariant"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "radius"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "space"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "chatColor"
                          },
                          {
                            "concreteType": "CsmAiWidgetBrandingAttribution",
                            "kind": "LinkedField",
                            "name": "attribution",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "CsmAiWidgetIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              },
              (v5/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9fa1deee69a7d7c1131a9266bda3498682040004679dac5904e341bd66455aa9",
    "metadata": {},
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ac8d157c5a0b96a5888ff99c54e68808";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
